import { type LeadBannerPayload } from '@travelata-libs/ui-shared';
import { useTravelataApiService, useTravelataAppConfig } from '@/shared/composables';
import { useSentryService } from '@/shared/di';
import { type BaseResponse } from '@/shared/model';

export const isRegionWithOffice = async (): Promise<boolean> => {
  const sentryService = useSentryService();
  const apiService = useTravelataApiService();
  const appConfig = useTravelataAppConfig();
  try {
    const response = await apiService.get<{ result: boolean, success: boolean; }>(
      `${appConfig.baseHost}/regions/isRegionWithOffices`,
      {
        headers: {
          'Content-type': 'application/json; charset=utf-8',
        },
      },
    );
    if (!response.success) {
      throw new Error('/regions/isRegionWithOffices success false');
    }
    return !!response.result;
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Неизвестная ошибка';
    sentryService.captureException(`Ошибка получения офиса /regions/isRegionWithOffices: ${message}`);
    return false;
  }
};
